import { render, staticRenderFns } from "./addQuotations.vue?vue&type=template&id=be12494e&scoped=true&"
import script from "./addQuotations.vue?vue&type=script&lang=js&"
export * from "./addQuotations.vue?vue&type=script&lang=js&"
import style0 from "./addQuotations.vue?vue&type=style&index=0&id=be12494e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be12494e",
  null
  
)

export default component.exports